<template>
  <div class="tile" :class="tileClass" @click="onTileClick(...tileObject.cords, 'l')" @contextmenu.prevent="onTileClick(...tileObject.cords, 'r')" @click.middle.prevent="onTileClick(...tileObject.cords, 'm')" @mouseenter="mouseOn = true" @mouseleave="mouseOn = false">
    <tile-unit v-if="displayUnit" :unit-object="tileObject.unit ? tileObject.unit : game.hoverUnit" :needs-margin="displayPointer"> </tile-unit>
    <tile-pointer v-if="displayPointer" :pointer-color="getPointerColor" :needs-margin="displayUnit"> </tile-pointer>
    <tile-badge v-if="showBadge" :badge-content="badgeNumber" badge-type="vehicle"> </tile-badge>
    <tile-badge v-if="showFlagIndicator" badge-type="flag"> </tile-badge>
  </div>
</template>

<script>
import TilePointer from './BoardTile/TilePointer.vue';
import TileUnit from './BoardTile/TileUnit.vue';
import TileBadge from './BoardTile/TileBadge.vue';

export default {
  components: { TilePointer, TileUnit, TileBadge },
  inject: ['groundTypes', 'onTileClick', 'selectMode', 'game'],
  data() {
    return {
      tileUnit: null,
      mouseOn: false,
      hoverUnit: null,
    }
  },
  props: {
    tileObject: {
      type: Object,
      required: true,
      validator(tile) {
        return tile.groundType && tile.pointer;
      }
    },
  },
  computed: {
    getPointerColor(){
      return this.tileObject.pointer.color;
    },
    displayPointer(){
      return this.tileObject.pointer.enabled;
    },
    displayUnit(){
      if(this.tileObject.unit || (this.tileObject.showHoverUnit && this.mouseOn)){
        return true;
      }
      return false;
    },
    badgeNumber() {
      let number = this.tileObject.unit.badgeNumber
      if(!number){
        number = this.game.countUnitsOnVehicle(this.tileObject.unit);
      }
      return number;
    },
    showBadge() {
      return this.tileObject.unit && (this.tileObject.unit.isVehicle || this.tileObject.unit.id === 'unknown') && this.badgeNumber > 0;
    },
    showFlagIndicator(){
      return this.tileObject.unit && this.tileObject.unit.isCarryingFlag;
    },
    tileClass() {
      const classes = [];
      if (this.tileObject.groundType === 's') {
        classes.push('sea-tile');
      }
      else{
        classes.push('sand-tile');
      }
      if (this.game.gameStage === 'prepStage'){
        if(this.tileObject.cords[1] > 10){
          classes.push('green-border');
        }
        else{
          classes.push('red-border');
        }
      }
      return classes;
    },
  },
}
</script>

<style scoped>
.tile{
    min-width: 40px;
    min-height: 40px;
    border: 1px solid black;
    margin: 1px;
    opacity: 0.85;
    transition: opacity 0.1s;
    user-select: none;
}
.tile:hover{
    opacity: 1
}
.sea-tile{
    background-image: url(../../../public/images/water-texture.jpg);
}
.sand-tile{
    background-image: url(../../../public/images/sand-texture.jpg);
}
</style>
